import { z } from 'zod'

/** 修改密码：8–32 位 + 复杂度（与 AppHeader 改密一致） */
export const strongPasswordSchema = z
  .string()
  .min(1, '请输入新密码')
  .max(32, '密码不超过 32 位')
  .refine((v) => v.length >= 8, '密码至少 8 位')
  .refine((v) => /[0-9]/.test(v), '密码须包含数字')
  .refine((v) => /[a-z]/.test(v), '密码须包含小写字母')
  .refine((v) => /[A-Z]/.test(v), '密码须包含大写字母')
  .refine((v) => /[^A-Za-z0-9]/.test(v), '密码须包含特殊字符')

/** 后台创建用户登录密码：保持与现有 API 一致（6–32 位） */
export const loginPasswordSchema = z
  .string()
  .min(1, '请输入登录密码')
  .min(6, '密码至少 6 位')
  .max(32, '密码不超过 32 位')
